import { DownloadIcon } from '@radix-ui/react-icons';
import { useConvex, useQuery } from 'convex/react';
import { toast } from 'sonner';
import { Button } from '@ui/Button';
import { useChatId } from '~/lib/stores/chatId';
import { convexProjectStore } from '~/lib/stores/convexProject';
import { useConvexSessionIdOrNullOrLoading } from '~/lib/stores/sessionId';
import { workbenchStore } from '~/lib/stores/workbench.client';
import { api } from '@convex/_generated/api';

export function DownloadButton() {
  const chatId = useChatId();
  const sessionId = useConvexSessionIdOrNullOrLoading();
  const convex = useConvex();

  const snapshotUrl = useQuery(api.snapshot.getSnapshotUrl, sessionId && chatId ? { sessionId, chatId } : 'skip');
  const hasSnapshot = snapshotUrl !== null && snapshotUrl !== undefined;

  const handleDownload = async () => {
    if (!sessionId || !chatId) {
      toast.error('Unable to download code right now.');
      return;
    }
    const convexProject = convexProjectStore.get();
    await workbenchStore.downloadZipFromSnapshot({
      chatId,
      sessionId,
      convex,
      convexProject: convexProject ?? null,
    });
  };

  return (
    <Button
      onClick={handleDownload}
      variant="neutral"
      size="xs"
      disabled={!hasSnapshot}
      tip={!hasSnapshot ? 'No code available for this chat' : undefined}
    >
      <DownloadIcon />
      <span>Download Code</span>
    </Button>
  );
}
